/**
 * @description i18n zh-CN
 * @author wangfupeng
 */

export default {
  tableModule: {
    deleteCol: '删除列',
    deleteRow: '删除行',
    deleteTable: '删除表格',
    widthAuto: '宽度自适应',
    insertCol: '插入列',
    insertRow: '插入行',
    insertTable: '插入表格',
    header: '表头',
  },
}
